import React, { useState, useEffect } from 'react'
import Verbanner from './VerBanner'
import SubirEditBanner from './SubirEditBanner'
import Eliminar from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import { Titulos, peticionDelete } from '../hooks/Funciones'
import moment from 'moment'

const BannerAdmin = ({ urlbanner, urlcategorias, titulo }) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [banner, setbanner] = useTraeDatos(urlbanner)
	const TitulosPagina = ['Ver banner', 'Crear banner', 'Editar banner', 'Eliminar banner', 'banner']
	const [copiaArray, setCopiaArray] = useTraeDatos(urlbanner)
	const [busqueda, setBusqueda] = useState('')

	const seleccionaRegistro = (dato, funcion) => e => {
		setRegistroSelect({ ...dato, imagePrev: dato.imagen, fechatermino: moment(dato.fechatermino, 'YYYY-MM-DD').toDate() })
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const peticionDeletee = () => { peticionDelete(registroSelect, urlbanner, banner, setbanner, setFuncion) }
	useEffect(() => { Titulos(funcion, setTituloPag, TitulosPagina) }, [funcion])

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if (item.nombre.toLowerCase().includes(termino.toLowerCase())) {
				return item
			}
		})
		setbanner(resultado)
	}

	const ReiniciarPaginacion = () => {
		setbanner(copiaArray)
		setBusqueda('')
	}


	return (
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'banner'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda} 
				resetBusq={ReiniciarPaginacion}
			/>
			{funcion === 'crear' ?
				<SubirEditBanner
					baseUrl={urlbanner}
					baseUrCategorias={urlcategorias}
					setFuncion={setFuncion}
					data={banner}
					setData={setbanner}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag}
					funcion={funcion} />
				: null}
			{funcion === 'editar' ?
				<SubirEditBanner
					baseUrl={urlbanner}
					baseUrCategorias={urlcategorias}
					setFuncion={setFuncion}
					data={banner}
					setData={setbanner}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag}
					registroSelect={registroSelect}
					funcion={funcion} />
				: null}
			{funcion === 'ver' ?
				<Verbanner
					data={banner}
					seleccionaRegistro={seleccionaRegistro}
					setFuncion={setFuncion}
					setRegistroSelect={setRegistroSelect}
					baseUrl={urlbanner}
				/>
				: null}
			{funcion === 'eliminar' ?
				<Eliminar
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee} />

				: null}
		</div>
	)
}

export default BannerAdmin